import { useNavigate, useSearchParams } from 'react-router-dom';
import { AddUserPage } from '@practium/features/users';
import type { SystemUserFormData } from '@practium/features/users';
import { useGetUserById } from '@practium/features/api';
import { usePermissions } from '@practium/features/permissions';
import { useAuth } from '@practium/features/auth';

export const ViewUserPageAdmin = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const { abilities } = usePermissions();
	const { user: currentUser } = useAuth();
	const id = searchParams.get('id') || '';

	const userQuery = useGetUserById(id, { enabled: !!id });

	if (userQuery.isLoading) return null;

	const user = userQuery.data;
	if (!user) return null;

	const { formData, avatarUrl } = user;
	const isSelf = currentUser?._id === user.id;
	const isProtectedMaster = formData.isMaster && !isSelf;
	const canDelete = abilities.can('delete', 'users') && !isProtectedMaster;
	const canEdit = abilities.can('update', 'users') && !isProtectedMaster;

	const initialData: SystemUserFormData = {
		name: formData.name,
		surName: formData.surName,
		phoneNumber: formData.phoneNumber,
		email: formData.email,
		planId: user.subscription?.plan?._id ?? '',
		status: formData.status ? 'true' : 'false',
		acceptedTerms: false,
	};

	return (
		<AddUserPage
			onBack={() => navigate('/usuarios')}
			initialMode="view"
			initialData={initialData}
			onDelete={canDelete ? () => navigate('/usuarios') : undefined}
			canEdit={canEdit}
			id={id}
			avatarUrl={avatarUrl}
		/>
	);
};
